import fetchWith403Redirect from './fetchWith403Redirect';
import { API_URL as API_BASE } from '../config/env';

const API_URL = `${API_BASE}/api/voucher-status-notes-counts`;

export async function getVoucherStatusNotesCounts(settlement_date_id) {
  const res = await fetchWith403Redirect(`${API_URL}?settlement_date_id=${settlement_date_id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });
  if (!res.ok) throw new Error('Failed to fetch notes counts');
  return res.json();
}
